"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterCategory = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var _filterState = require("../util/filter-state.js");

var _testId = require("../util/test-id.js");

var _jsxRuntime = require("react/jsx-runtime");

var OptionWrapper = _styledComponents["default"].button.withConfig({
  displayName: "OptionWrapper",
  componentId: "sc-81qzyd-0"
})(["background:none;border-style:solid;border-width:2px;border-color:", ";border-radius:8px;padding:8px;white-space:nowrap;"], function (_ref) {
  var theme = _ref.theme,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive;
  return isActive ? theme.bubbleBlue500 : theme.scuttleGray200;
});

var Option = (0, _styledComponents["default"])(function (_ref2) {
  var isActive = _ref2.isActive,
      onClick = _ref2.onClick,
      children = _ref2.children,
      className = _ref2.className;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(OptionWrapper, {
    className: className,
    onClick: onClick,
    isActive: isActive,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
      bold: isActive,
      children: children
    })
  });
}).withConfig({
  displayName: "Option",
  componentId: "sc-81qzyd-1"
})([""]);
Option.displayName = 'Option';

var OptionsContainer = _styledComponents["default"].div.withConfig({
  displayName: "OptionsContainer",
  componentId: "sc-81qzyd-2"
})(["display:flex;flex-direction:row;flex-wrap:wrap;align-items:flex-start;justify-content:flex-start;& > ", "{flex:0 0 auto;margin:0 16px 16px 0;}& > ", ":last-child{margin:0 0 16px 0;}"], Option, Option);

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-81qzyd-3"
})(["& > ", "{margin-bottom:16px;}"], _baseReactComponents.Copy);

var FilterCategory = (0, _styledComponents["default"])(function (_ref3) {
  var _activeFilters$name;

  var name = _ref3.name,
      _ref3$options = _ref3.options,
      options = _ref3$options === void 0 ? [] : _ref3$options,
      onChange = _ref3.onChange,
      activeFilters = _ref3.activeFilters,
      _ref3$isSingleOption = _ref3.isSingleOption,
      isSingleOption = _ref3$isSingleOption === void 0 ? false : _ref3$isSingleOption,
      _ref3$isInUse = _ref3.isInUse,
      isInUse = _ref3$isInUse === void 0 ? false : _ref3$isInUse,
      _ref3$multiSelectEnab = _ref3.multiSelectEnabled,
      multiSelectEnabled = _ref3$multiSelectEnab === void 0 ? false : _ref3$multiSelectEnab,
      _ref3$filterResetText = _ref3.filterResetText,
      filterResetText = _ref3$filterResetText === void 0 ? 'View All' : _ref3$filterResetText,
      className = _ref3.className;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Wrapper, {
    className: className,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
      bold: true,
      "data-testid": "full-screen-filter:category-heading-".concat((0, _testId.formatForTestId)(name)),
      children: name
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(OptionsContainer, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Option, {
        isActive: ((_activeFilters$name = activeFilters[name]) !== null && _activeFilters$name !== void 0 ? _activeFilters$name : []).length === 0 || options.every(function (option) {
          return activeFilters[name].includes(option);
        }),
        onClick: function onClick() {
          return onChange((0, _filterState.omit)(activeFilters, name));
        },
        "data-testid": "full-screen-filter:reset-option",
        children: filterResetText
      }), options.map(function (option) {
        var _activeFilters$name2;

        var isActive = ((_activeFilters$name2 = activeFilters[name]) !== null && _activeFilters$name2 !== void 0 ? _activeFilters$name2 : []).some(function (activeOption) {
          return activeOption === option;
        });
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(Option, {
          isActive: isActive,
          onClick: function onClick() {
            return onChange(isActive ? (0, _filterState.removeFilterOptions)(activeFilters, name, [option]) : multiSelectEnabled ? (0, _filterState.addFilterOptions)(activeFilters, name, [option]) : (0, _filterState.set)(activeFilters, name, option));
          },
          "data-testid": "full-screen-filter:option-".concat((0, _testId.formatForTestId)(name), "-").concat((0, _testId.formatForTestId)(option)),
          children: option
        }, option);
      })]
    })]
  });
}).withConfig({
  displayName: "FilterCategory",
  componentId: "sc-81qzyd-4"
})([""]);
exports.FilterCategory = FilterCategory;
FilterCategory.displayName = 'FilterCategory';
//# sourceMappingURL=filter-category.js.map